<template>
  <section class="news-section" v-if="news.length">
    <div class="container">
      <h2 class="section-title">Aktualności</h2>
      <div class="news-list">
        <article class="single-item" v-for="(article, index) in news" :key="index">
          <div class="image">
            <img :src="article.image" :alt="article.image_alt">
          </div>
          <h3 class="title">{{ article.title }}</h3>
          <p class="desc" v-html="article.description"></p>
          <div class="more-btn-ctr">
            <a :href="article.url" class="more-btn">
              <span>Zobacz więcej</span>
              <i class="fas fa-arrow-circle-right"></i>
            </a>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NewsFeed',
  computed: {
    news() {
      return this.$store.state.news.list;
    },
  },
  created() {
    this.$store.dispatch('news/fetchFromServer');
  },
};
</script>

<style scoped>
.news-section {
  margin: 50px 0;
}

.section-title {
  text-align: justify;
  font-size: 35px;
  margin: 0 0 30px;
  border-bottom: 5px solid var(--color-main);
  display: inline-block;
  padding: 0 10px 4px;
  letter-spacing: 2px;
}

.news-list {
  display: flex;
  flex-flow: row wrap;
  margin: 0 -50px;
}

.news-list .single-item {
  width: 33.333333%;
  display: flex;
  flex-flow: column nowrap;
  padding: 20px 50px;
  border-right: dashed 1px rgb(202, 202, 202);
}

.news-list .single-item:last-of-type {
  border-right: none;
}

.news-list .single-item .image img {
  height: 250px;
  width: 100%;
  object-fit: cover;
}

.news-list .single-item .title {
  font-size: 20px;
  line-height: 25px;
  text-align: justify;
}

.news-list .single-item .desc {
  flex: 1 1 auto;
  margin: 0;
  text-align: justify;
  line-height: 23px;
}

.news-list .single-item .more-btn-ctr {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.news-list .single-item .more-btn {
  border: 1px solid var(--color-main);
  color: var(--color-main);
  display: flex;
  border-radius: 4px;
  transition: color 0.3s ease, background-color 0.3s ease;
}

.news-list .single-item .more-btn span {
  padding: 10px 15px;
  font-size: 17px;
}

.news-list .single-item .more-btn i {
  background-color: var(--color-main);
  color: #fff;
  height: 100%;
  width: 40px;
  padding: 0 5px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
}

.news-list .single-item .more-btn:hover {
  border: 1px solid var(--color-second);
  color: var(--color-second);
}

.news-list .single-item .more-btn:hover i {
  background-color: var(--color-second);
}

</style>
